import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { animate, stagger } from 'animejs';
import './Services.css';
import AnimatedBackground from './AnimatedBackground';

const Services = () => {
  const { t } = useTranslation();
  const gridRef = useRef(null);
  const leftRef = useRef(null);

  const navigateToPage = (path) => {
    window.history.pushState({}, '', path);
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  const services = [
    {
      titleKey: 'serviciosHub.yogaTitle',
      icon: 'spa',
      descKey: 'serviciosHub.yogaDesc',
      buttonKey: 'serviciosHub.yogaCta',
      path: '/bienestar/yoga',
      accent: 'nature',
    },
    {
      titleKey: 'serviciosHub.trainingTitle',
      icon: 'dumbbell',
      descKey: 'serviciosHub.trainingDesc',
      buttonKey: 'serviciosHub.trainingCta',
      path: '/bienestar/entrenamiento',
      accent: 'earth',
    },
    {
      titleKey: 'serviciosHub.conectaTitle',
      icon: 'brain',
      descKey: 'serviciosHub.conectaDesc',
      buttonKey: 'serviciosHub.conectaCta',
      path: '/bienestar/conecta',
      accent: 'warm',
    },
    {
      titleKey: 'serviciosHub.travelTitle',
      icon: 'map-marked-alt',
      descKey: 'serviciosHub.travelDesc',
      buttonKey: 'serviciosHub.travelCta',
      path: '/conoce-colombia',
      accent: 'earth',
    },
    {
      titleKey: 'serviciosHub.growthTitle',
      icon: 'chart-line',
      descKey: 'serviciosHub.growthDesc',
      buttonKey: 'serviciosHub.growthCta',
      path: '/growth-partner',
      accent: 'warm',
    },
  ];

  useEffect(() => {
    const grid = gridRef.current;
    const left = leftRef.current;
    if (!grid) return;

    const cards = grid.querySelectorAll('.service-card-ecosystem');
    cards.forEach((card) => {
      card.style.opacity = '0';
      card.style.transform = 'translateY(54px)';
    });
    if (left) {
      left.style.opacity = '0';
      left.style.transform = 'translateX(-40px)';
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          if (left) {
            animate(left, {
              opacity: [0, 1],
              translateX: [-40, 0],
              duration: 700,
              ease: 'outExpo',
            });
          }
          animate(cards, {
            opacity: [0, 1],
            translateY: [54, 0],
            delay: stagger(110),
            duration: 650,
            ease: 'outExpo',
          });
          observer.disconnect();
        });
      },
      { threshold: 0.08 }
    );

    observer.observe(grid);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="services services-hero-inverted" id="servicios">
      <AnimatedBackground particleCount={6} staticCount={2} />
      <div className="services-inverted-layout">
        <div className="services-content-side" ref={leftRef}>
          <span className="services-tag">{t('services.tag')}</span>
          <h2 className="services-headline">{t('services.headline')}</h2>
          <p className="services-subtitle">{t('services.subtitle')}</p>
          <button className="services-cta" type="button" onClick={() => navigateToPage('/servicios')}>
            {t('services.viewServices')}
          </button>
        </div>

        <div className="services-grid-side services-grid-side--five" ref={gridRef}>
          {services.map((s) => (
            <div
              key={s.path}
              className={`service-card-ecosystem service-card-accent-${s.accent}`}
              onClick={() => navigateToPage(s.path)}
            >
              <div className="service-card-ecosystem-inner">
                <div className="service-icon-ecosystem">
                  <i className={`fas fa-${s.icon}`} />
                </div>
                <h3 className="service-title-ecosystem">{t(s.titleKey)}</h3>
                <p className="service-desc-ecosystem">{t(s.descKey)}</p>
                <button
                  type="button"
                  className="service-btn-ecosystem"
                  onClick={(e) => { e.stopPropagation(); navigateToPage(s.path); }}
                >
                  {t(s.buttonKey)}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
